export default "__VITE_ASSET__BnHBHLQg__"